import script from "./subjectBox.vue?vue&type=script&setup=true&lang=js"
export * from "./subjectBox.vue?vue&type=script&setup=true&lang=js"

import "./subjectBox.vue?vue&type=style&index=0&id=2a52fd5a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a52fd5a"]])

export default __exports__